import { render, staticRenderFns } from "./ShipmentsHistoryTableComponent.vue?vue&type=template&id=5fb9b6c1&scoped=true"
import script from "./ShipmentsHistoryTableComponent.vue?vue&type=script&lang=js"
export * from "./ShipmentsHistoryTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsHistoryTableComponent.vue?vue&type=style&index=0&id=5fb9b6c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb9b6c1",
  null
  
)

export default component.exports